<template lang="html">
    <div id="d-page-template-1">

      <section class="short-info-section-s1">
        <div class="box-top">
          <div class="col-sm-12 mb-2 col-title">
            <h2>On Job Training</h2>
          </div>

          <b-button class="btn-s1 bg-red btn-sm" style="float: right;background-color: black;border-color: black;" @click="$refs.modalPosition.open()">Descripción de puesto</b-button>

        </div>
      </section>

      <section class="evaluations-section" v-if="!loading">
        <div class="box-progress">
          <div class="col-sm-5 col-md-4 col-xl-3 col-info col-hours">
            <h4 class="label">Total Horas: </h4>
            <h5 class="info">{{ total_hours }}</h5>
          </div>

          <div class="col-sm-5 col-info col-progress">
            <h4 class="mr-3 label">Avance total: </h4>

            <vc-donut :total="100" :size="85" unit="px" :thickness="15" :sections="[{ value: 97, color: '#8a0e0a' }]">
              <span class="chart-number">97%
                <!-- {{ total_advance }} -->
              </span>
            </vc-donut>
          </div>
        </div>

        <div class="box-results">
          <b-card no-body>
            <b-tabs class="tabs-lg" card>

              <b-card-text>
                <div class="no-gutters post-template-s6" v-for="(v, vInx) in rows" :key="'vInx-'+vInx">
                  <!--  -->
                  <div class="box-content">
                    <div class="box-title">
                      <h6 class="t">{{ v.name }}</h6>
                    </div>

                    <p class="text-center py-2 f-s-0-95" v-if="v.objetive">
                      {{ v.objetive }}
                    </p>
                  </div>

                  <div class="box-content border-0">
                    <div class="table-s1">
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead class="thead-dark">
                            <tr class="bg-semiblack">
                              <th class="c-horas">Horas</th>
                              <th class="c-avance">% Avance</th>
                              <th class="c-ncurso">Nombre del curso</th>
                              <th class="c-temas">Temas</th>
                              <th class="">Tutor</th>
                              <th>Impartido por</th>
                              <th class="">Fecha programada</th>
                              <th class="c-txt-sm c-firma">Firma colaborador</th>
                              <th class="c-txt-sm c-firma">Firma tutor</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(ob, obj) in v.details" :key="'obj-'+obj">
                              <td>{{ ob.hours }}</td>
                              <td>{{ ob.advance }}</td>
                              <td class="c-txt-md f-w-600">{{ ob.course_name }}</td>
                              <td class="c-txt-sm">{{ ob.topics }}</td>
                              <td class="c-txt-md f-w-600">{{ ob.tutor }}</td>
                              <td class="c-txt-md">{{ ob.imparted_by }}</td>
                              <td class="c-txt-md">{{ ob.date }}</td>
                              <td>
                                <div class="checkbox-wrapper-19 checkbox-arrow"> <!--c-disabled-->
                                  <!-- <input type="checkbox" :id="'cbtest-19-'+v.id+'-'+ob.id" :name="'col_sig'+obj"  v-model="ob.collaborator_signature" @change=""/>
                                  <label :for="'cbtest-19-'+v.id+'-'+ob.id" class="check-box"></label> -->
                                  <button class="btn btn-secondary btn-sm" v-if="!ob.collaborator_signature" @click="saveSing(ob.id)">Firmar</button>
                                  <button class="btn btn-secondary btn-sm" v-else style="background-color: black;border-color: black;" @click="showSign(ob.collaborator_signature)">Firmado</button>
                                </div>

                              </td>
                              <td>
                                <div class="checkbox-wrapper-19 checkbox-arrow">
                                  <input type="checkbox"  :id="'cbtest-19_tu-'+v.id+'-'+ob.id" :name="'tut_sig'+obj" v-model="ob.tutor_signature" disabled/>
                                  <label :for="'cbtest-19_tu-'+v.id+'-'+ob.id" class="check-box"></label>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <!--  -->
                </div>
              </b-card-text>

            </b-tabs>
          </b-card>
        </div>
      </section>
      <section class="evaluations-section" v-else>
        <div class="box-results"  style="padding-top: 150px;text-align: center;">
          <div class="fa-5x"><i class="fas fa-spinner fa-pulse"></i></div><br>
        </div>
      </section>
      <sweet-modal ref="modalPosition" width="60%">

        <b-form class="form" @submit="onSubmit" >
          <div class="row">
            <div class="col-lg-12">
              <p style="text-align: center;background-color: black;color: white;"><b>Organigrama</b></p>
                <a :href="infoposition.imageUrl" target="_blank" rel="noopener noreferrer">
                  <img :src="infoposition.imageUrl" width="40%">
                </a>
                <a :href="infoposition.documentUrl" target="_blank" rel="noopener noreferrer" class="btn-s1 bg-red btn-sm" style="background-color: black;"><i class="fas fa-download"></i> Descargar</a>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Nombre">
                <b-form-input
                  v-model="infoposition.name"
                  type="text"
                  disabled
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Area">
                <b-form-input
                  v-model="infoposition.area"
                  type="text"
                  disabled
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Departamento">
                <b-form-input
                  v-model="infoposition.departament"
                  type="text"
                  disabled
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-6"></div>

            <div class="col-lg-12">
              <p style="text-align: center;background-color: black;color: white;"><b>Perfil del puesto (Requerimientos del ocupante)</b></p>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Escolaridad">
                <div v-html="infoposition.scholarship" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Requiere viajar">
                <div v-html="infoposition.requires_travel" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>

            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Tipo de puesto">
                <div v-html="infoposition.kind_position" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Idiomas">
                <div v-html="infoposition.languages" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>


            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Sistemas">
                <div v-html="infoposition.systems" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Habilidades y Competencias Genéricas">
                <div v-html="infoposition.skills" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Competencias y conocimientos específicos">
                <div v-html="infoposition.competencies" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Cualidades Personales">
                <div v-html="infoposition.qualities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>


            <div class="col-lg-12">
              <p style="text-align: center;background-color: black;color: white;"><b>Descripción del puesto (objetivo, funciones y responsabilidades)</b></p>
            </div>


            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Objetivo del puesto">
                <div v-html="infoposition.objective" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">  </div>
            <div class="col-lg-12">Relaciones del puesto</div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Interior">

                <div v-html="infoposition.inside" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Exterior">

                <div v-html="infoposition.abroad" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Reporta a">
                <div v-html="infoposition.report_to" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Supervisa a">
                <div v-html="infoposition.supervises_to" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Material, herramientas y equipo asignado">
                <div v-html="infoposition.material_tools" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>

            <div class="col-lg-12">Resposabilidades</div>


            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Actividades Diarias">
                <div v-html="infoposition.daily_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Actividades Semanales">
                <div v-html="infoposition.weekly_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Actividades Quincenales">

                <div v-html="infoposition.biweekly_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Actividades Mensuales">
                <div v-html="infoposition.monthly_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Actividades Anuales">
                <div v-html="infoposition.annual_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Actividades Eventuales">
                <div v-html="infoposition.eventual_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>

            <div class="col-lg-6">  </div>
            <div class="col-lg-12">Condiciones de trabajo</div>

            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Lugar">
                <div v-html="infoposition.place" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Principales riesgos a los que se expone el ocupante del puesto">
                <div v-html="infoposition.main_risks" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-12">
              <b-form-group class="mb-4 form-group-s1"
                label="Políticas y Procedimientos">
                <div v-html="infoposition.politics_procedures" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Emisión">
                <div v-html="infoposition.issue" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Última actualización">
                <div v-html="infoposition.last_update" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Última revisión">
                <div v-html="infoposition.last_revision" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Próxima revisión">
                <div v-html="infoposition.next_review" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>

            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Elaboró">
                <div v-html="infoposition.elaborated" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Autorizó">
                <div v-html="infoposition.authorize" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>
            <div class="col-lg-6">
              <b-form-group class="mb-4 form-group-s1"
                label="Revisó">
                <div v-html="infoposition.revised" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
              </b-form-group>
            </div>

          </div>
        </b-form>
        </sweet-modal>

      <b-modal modal-class="modal-signature" size="lg" ref="modal-signature" centered hide-footer title="" @hidden="showSignaturePad = false">
        <div class="box-content" >
          <p style="text-align: center;">Firma en el recuadro</p>
          <div class="box-signature" v-if="showSignaturePad" style="text-align: center;">
            <VueSignaturePad class="signature-pad" ref="signaturePad" style="border:1px solid" />

            <div class="box-buttons">
              <button class="btn btn-primary" style="background-color: black; border-color: black;" @click="resetSignature">Intentar de nuevo</button>
              <button class="btn btn-secondary" @click="saveSignature">Guardar firma</button>

            </div>
          </div>
        </div>
      </b-modal>

      <b-modal modal-class="modal-show-signature" size="lg" ref="modal-show-signature" centered hide-footer title="">
        <div class="box-content" >
            <img :src="collaborator_signature_url">
        </div>
      </b-modal>


    </div>
  </template>


  <script>
  export default {
    data() {
      return {
        formSearch: {
          keywords: null
        },
        rows:[],
        others:[],
        infoposition:{},
        total_advance:0,
        total_hours:0,
        loading:false,
        showSignaturePad: false,
        signatureUrl:null,
        formSign:{
          id:null,
          signatureUrl:null,
        },
        collaborator_signature_url:null,
      }
    },

    methods: {
      onSubmit(event) {
        event.preventDefault();
      },
      getRows(){

        axios.get(tools.url("/api/ojts")).then((response)=>{
            this.rows = response.data;
            var total_advance_aux = 0;
            var total_hours_aux = 0;
            for (let z = 0; z < this.rows.length; z++) {
                var  total_advance = 0;
                var  total_hours = 0;
                for (let x = 0; x < this.rows[z].details.length; x++) {
                    total_advance += parseFloat(this.rows[z].details[x]['advance']);
                    total_hours += parseFloat(this.rows[z].details[x]['hours']);
                }

                total_advance_aux += total_advance;
                total_hours_aux += total_hours;
            }

            this.total_advance = total_advance_aux;
            this.total_hours = total_hours_aux;

        }).catch(()=>{

        });
      },
      getInfoPosition(){
        axios.get(tools.url('/api/positions/' + this.$root.user.positions_id)).then((response)=>{
            this.infoposition = response.data;
          }).catch((error)=>{
            console.log(error);
          });
      },
      saveSing(id){
        this.formSign = {
            id:id,
            signatureUrl:null,
        };
        this.$refs['modal-signature'].show();

        setTimeout(()=>{ this.showSignaturePad = true; }, 500);

      },

      resetSignature() {
        this.$refs.signaturePad.clearSignature();
      },
      saveSignature() {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
       this.formSign.signatureUrl = data;

        axios.post(tools.url("/api/ojtssave"),this.formSign).then((response)=>{
          this.getRows();
          this.$refs['modal-signature'].hide();
        }).catch(()=>{});
      },
      showSign(collaborator_signature){
        this.collaborator_signature_url = collaborator_signature;
        this.$refs['modal-show-signature'].show();
      }
    },
    mounted(){
      this.loading = true;
        this.getRows();
        this.getInfoPosition();
        this.loading = false;
    }
  }
  </script>
<style>
.checkbox-wrapper-19 {
  box-sizing: border-box;
  --background-color: #fff;
  --checkbox-height: 25px;
}

@-moz-keyframes dothabottomcheck-19 {
  0% {
    height: 0;
  }
  100% {
    height: calc(var(--checkbox-height) / 2);
  }
}

@-webkit-keyframes dothabottomcheck-19 {
  0% {
    height: 0;
  }
  100% {
    height: calc(var(--checkbox-height) / 2);
  }
}

@keyframes dothabottomcheck-19 {
  0% {
    height: 0;
  }
  100% {
    height: calc(var(--checkbox-height) / 2);
  }
}

@keyframes dothatopcheck-19 {
  0% {
    height: 0;
  }
  50% {
    height: 0;
  }
  100% {
    height: calc(var(--checkbox-height) * 1.2);
  }
}

@-webkit-keyframes dothatopcheck-19 {
  0% {
    height: 0;
  }
  50% {
    height: 0;
  }
  100% {
    height: calc(var(--checkbox-height) * 1.2);
  }
}

@-moz-keyframes dothatopcheck-19 {
  0% {
    height: 0;
  }
  50% {
    height: 0;
  }
  100% {
    height: calc(var(--checkbox-height) * 1.2);
  }
}

.checkbox-wrapper-19 input[type=checkbox] {
  display: none;
}

.checkbox-wrapper-19 .check-box {
  height: var(--checkbox-height);
  width: var(--checkbox-height);
  background-color: transparent;
  border: calc(var(--checkbox-height) * .1) solid #000;
  border-radius: 5px;
  position: relative;
  display: inline-block;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -moz-transition: border-color ease 0.2s;
  -o-transition: border-color ease 0.2s;
  -webkit-transition: border-color ease 0.2s;
  transition: border-color ease 0.2s;
  cursor: pointer;
}
.checkbox-wrapper-19 .check-box::before,
.checkbox-wrapper-19 .check-box::after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  height: 0;
  width: calc(var(--checkbox-height) * .2);
  background-color: black;
  display: inline-block;
  -moz-transform-origin: left top;
  -ms-transform-origin: left top;
  -o-transform-origin: left top;
  -webkit-transform-origin: left top;
  transform-origin: left top;
  border-radius: 5px;
  content: " ";
  -webkit-transition: opacity ease 0.5;
  -moz-transition: opacity ease 0.5;
  transition: opacity ease 0.5;
}
.checkbox-wrapper-19 .check-box::before {
  top: calc(var(--checkbox-height) * .72);
  left: calc(var(--checkbox-height) * .41);
  box-shadow: 0 0 0 calc(var(--checkbox-height) * .05) var(--background-color);
  -moz-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
  -o-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}
.checkbox-wrapper-19 .check-box::after {
  top: calc(var(--checkbox-height) * .37);
  left: calc(var(--checkbox-height) * .05);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.checkbox-wrapper-19 input[type=checkbox]:checked + .check-box,
.checkbox-wrapper-19 .check-box.checked {
  border-color: black;
}
.checkbox-wrapper-19 input[type=checkbox]:checked + .check-box::after,
.checkbox-wrapper-19 .check-box.checked::after {
  height: calc(var(--checkbox-height) / 2);
  -moz-animation: dothabottomcheck-19 0.2s ease 0s forwards;
  -o-animation: dothabottomcheck-19 0.2s ease 0s forwards;
  -webkit-animation: dothabottomcheck-19 0.2s ease 0s forwards;
  animation: dothabottomcheck-19 0.2s ease 0s forwards;
}
.checkbox-wrapper-19 input[type=checkbox]:checked + .check-box::before,
.checkbox-wrapper-19 .check-box.checked::before {
  height: calc(var(--checkbox-height) * 1.2);
  -moz-animation: dothatopcheck-19 0.4s ease 0s forwards;
  -o-animation: dothatopcheck-19 0.4s ease 0s forwards;
  -webkit-animation: dothatopcheck-19 0.4s ease 0s forwards;
  animation: dothatopcheck-19 0.4s ease 0s forwards;
}
</style>
